import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { Interaction } from '@dbk/ui-charts';
import { Card, CardBody, CardHeader } from '@dbk/ui-card';

import { ChangeIndicatedPercent } from '../../common/number';
import Text from '@dbk/ui-text';

import styles from './interactions.styles';

import theme from '@dbk/ui-theme';

const VERTICAL_OFFSET = 95;

function Interactions({ data, currency, selectedValue, onChange, messages }) {
  return (
    <Interaction selectedValue={selectedValue}
                 onChange={onChange}
                 xAxis="x">
      <Interaction.XGroup>
        <Interaction.HideLink>
          <Interaction.VerticalLine
            top={VERTICAL_OFFSET}
            gaps={[ { axis: 'y', gap: 10 } ]}
          />
          <Interaction.YGroup axis="y">
            <Interaction.Circle
              d={10}
              strokeWidth={0}
              fill={theme.palettePrimaryActive}
            />
          </Interaction.YGroup>
        </Interaction.HideLink>
        <Interaction.DataPointView
          top={0}
          view={item => {
            return (
              <View style={styles.flag}>
              <View>
                <View>
                  <View style={styles.cardHeaderView}>
                    <Text id="text_portfolio_cumulativeChart_test" secondary style={{
                      textAlign: 'center',
                      fontSize: 16,
                      color: '#ffffff',
                    }}>
                      {`${messages[item.titleText].toUpperCase()} ${item.incYear}`}
                    </Text>
                  </View>
                </View>
                <View>
                  <View style={styles.cardBodyView}>
                    <View>
                      <ChangeIndicatedPercent
                        value={item.value}
                        renderProps={{ size: 'large'}}
                        withPlusSign
                      />
                      <Text secondary style={{ textAlign: 'center', color: '#ffffff', fontSize: 16,}}>
                        {messages[ 'app.portfolio.dashboard.performance.monthlyTxt' ]}
                      </Text>
                    </View>
                    <View>
                      <ChangeIndicatedPercent
                        value={item.cumulativeVal}
                        renderProps={{ size: 'large', type: 'secondary' }}
                        withPlusSign
                      />
                      <Text secondary style={{ textAlign: 'center', color: '#ffffff', fontSize: 16,}}>
                        {messages[ 'app.portfolio.dashboard.performance.cumulativeTxt' ]}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            )}}
        />
      </Interaction.XGroup>
    </Interaction>
  );
}

Interactions.propTypes = {
  data: PropTypes.array.isRequired,
  currency: PropTypes.string,
  selectedValue: Interaction.propTypes.selectedValue,
  onChange: PropTypes.func,
};

export default Interactions;
